import AccountCircleSvg from "@material-symbols/svg-300/outlined/account_circle.svg";
import AcuteSvg from "@material-symbols/svg-300/outlined/acute.svg";
import PlusSvg from "@material-symbols/svg-300/outlined/add.svg";
import AdminPanelSettingsSvg from "@material-symbols/svg-300/outlined/admin_panel_settings.svg";
import Building2Svg from "@material-symbols/svg-300/outlined/apartment.svg";
import ApiSvg from "@material-symbols/svg-300/outlined/api.svg";
import ArrowBackSvg from "@material-symbols/svg-300/outlined/arrow_back.svg";
import ArrowForwardSvg from "@material-symbols/svg-300/outlined/arrow_forward.svg";
import AssuredWorkloadSvg from "@material-symbols/svg-300/outlined/assured_workload.svg";
import DollarSignSvg from "@material-symbols/svg-300/outlined/attach_money.svg";
import BalanceSvg from "@material-symbols/svg-300/outlined/balance.svg";
import BrickSvg from "@material-symbols/svg-300/outlined/brick.svg";
import CandlestickChartSvg from "@material-symbols/svg-300/outlined/candlestick_chart.svg";
import ChevronRightSvg from "@material-symbols/svg-300/outlined/chevron_right.svg";
import CloseSvg from "@material-symbols/svg-300/outlined/close.svg";
import CompareArrowsSvg from "@material-symbols/svg-300/outlined/compare_arrows.svg";
import CurrencyExchangeSvg from "@material-symbols/svg-300/outlined/currency_exchange.svg";
import DeviceHubSvg from "@material-symbols/svg-300/outlined/device_hub.svg";
import DonutLargeSvg from "@material-symbols/svg-300/outlined/donut_large.svg";
import DonutSmallSvg from "@material-symbols/svg-300/outlined/donut_small.svg";
import EditSvg from "@material-symbols/svg-300/outlined/edit.svg";
import FastForwardSvg from "@material-symbols/svg-300/outlined/fast_forward.svg";
import SparklesSvg from "@material-symbols/svg-300/outlined/flare.svg";
import GavelSvg from "@material-symbols/svg-300/outlined/gavel.svg";
import Graph5Svg from "@material-symbols/svg-300/outlined/graph_5.svg";
import GroupSvg from "@material-symbols/svg-300/outlined/group.svg";
import UsersSvg from "@material-symbols/svg-300/outlined/groups.svg";
import HandshakeSvg from "@material-symbols/svg-300/outlined/handshake.svg";
import History2Svg from "@material-symbols/svg-300/outlined/history_2.svg";
import BoxSvg from "@material-symbols/svg-300/outlined/inventory_2.svg";
import ChevronDownSvg from "@material-symbols/svg-300/outlined/keyboard_arrow_down.svg";
import KeyboardArrowDownSvg from "@material-symbols/svg-300/outlined/keyboard_arrow_down.svg";
import KeyboardArrowRightSvg from "@material-symbols/svg-300/outlined/keyboard_arrow_right.svg";
import ArrowUpSvg from "@material-symbols/svg-300/outlined/keyboard_arrow_up.svg";
import LanguageSvg from "@material-symbols/svg-300/outlined/language.svg";
import LayersSvg from "@material-symbols/svg-300/outlined/layers.svg";
import LightbulbSvg from "@material-symbols/svg-300/outlined/lightbulb.svg";
import LocalLibrarySvg from "@material-symbols/svg-300/outlined/local_library.svg";
import LocationSvg from "@material-symbols/svg-300/outlined/location_on.svg";
import LockSvg from "@material-symbols/svg-300/outlined/lock.svg";
import EmailSvg from "@material-symbols/svg-300/outlined/mail.svg";
import MenuSvg from "@material-symbols/svg-300/outlined/menu.svg";
import ArrowUpRightSvg from "@material-symbols/svg-300/outlined/open_in_new.svg";
import PersonSvg from "@material-symbols/svg-300/outlined/person.svg";
import PersonShieldSvg from "@material-symbols/svg-300/outlined/person_shield.svg";
import PhoneSvg from "@material-symbols/svg-300/outlined/phone_enabled.svg";
import GlobeSvg from "@material-symbols/svg-300/outlined/public.svg";
import PublicSvg from "@material-symbols/svg-300/outlined/public.svg";
import MinusSvg from "@material-symbols/svg-300/outlined/remove.svg";
import RocketLaunchSvg from "@material-symbols/svg-300/outlined/rocket_launch.svg";
import CoinsSvg from "@material-symbols/svg-300/outlined/savings.svg";
import SearchSvg from "@material-symbols/svg-300/outlined/search.svg";
import SettingsSvg from "@material-symbols/svg-300/outlined/settings.svg";
import ShieldLockSvg from "@material-symbols/svg-300/outlined/shield_lock.svg";
import StarSvg from "@material-symbols/svg-300/outlined/star.svg";
import ArrowLeftRightSvg from "@material-symbols/svg-300/outlined/sync_alt.svg";
import TokenSvg from "@material-symbols/svg-300/outlined/token.svg";
import TrendingUpSvg from "@material-symbols/svg-300/outlined/trending_up.svg";
import VerifiedSvg from "@material-symbols/svg-300/outlined/verified.svg";
import VerifiedUserSvg from "@material-symbols/svg-300/outlined/verified_user.svg";
import VisibilitySvg from "@material-symbols/svg-300/outlined/visibility.svg";
import Volume2Svg from "@material-symbols/svg-300/outlined/volume_up.svg";
import VpnKeySvg from "@material-symbols/svg-300/outlined/vpn_key.svg";
import WhatshotSvg from "@material-symbols/svg-300/outlined/whatshot.svg";
import WidgetsSvg from "@material-symbols/svg-300/outlined/widgets.svg";
import tZeroLogoSvg from "@public/logos/tZERO.png";
import type { StaticImageData } from "next/image";
import Image from "next/image";
import React, { type FC, type SVGProps } from "react";

import BankShield from "@/assets/svg/BankShield.svg";
import Documents from "@/assets/svg/Documents.svg";
import FacebookSvg from "@/assets/svg/Facebook.svg";
import Global from "@/assets/svg/Global.svg";
import GoogleSvg from "@/assets/svg/Google.svg";
import Hexagon from "@/assets/svg/Hexagon.svg";
import InstagramSvg from "@/assets/svg/Instagram.svg";
import LinkedinSvg from "@/assets/svg/LinkedIn.svg";
import Stats from "@/assets/svg/Stats.svg";
import Trading from "@/assets/svg/Trading.svg";
import XSvg from "@/assets/svg/X.svg";
import { stripStega } from "@/lib/sanity/stega";
import { cn } from "@/lib/ui/cn";

/**
 * PNG Icon Images
 *
 * Icons are automatically imported from `public/icons/` directory.
 * The script scans subdirectories and generates imports automatically.
 * Run `pnpm run generate:icons` to regenerate after adding new PNG files.
 *
 * Naming convention:
 * - Icons in `active/` folder: `Active{IconName}` (e.g., "ActiveApi", "ActiveWidget")
 * - Icons in `deafult/` folder: `Deafult{IconName}` (e.g., "DeafultApi", "DeafultWidget")
 *
 * Usage in components:
 * ```tsx
 * import { iconImage } from "@/components/ui/icons";
 * import Image from "next/image";
 *
 * const MyComponent = () => {
 *   const defaultIcon = iconImage("DeafultApi");
 *   const activeIcon = iconImage("ActiveApi");
 *   return (
 *     <div>
 *       <Image src={defaultIcon} alt="API Icon" width={24} height={24} />
 *       <Image src={activeIcon} alt="API Icon Active" width={24} height={24} />
 *     </div>
 *   );
 * };
 * ```
 */
import { iconImageMap, type IconImageName as GeneratedIconImageName } from "./icon-images";

const rawIconImages = iconImageMap;

type IconComponent = FC<SVGProps<SVGSVGElement>>;

const withCurrentColor = (name: string, Icon: IconComponent): IconComponent => {
  const Wrapped: IconComponent = ({ fill, stroke, ...props }) => (
    <Icon
      fill={fill ?? "currentColor"}
      stroke={stroke ?? "currentColor"}
      {...props}
      className={cn(`icon-${name}`, props.className)}
    />
  );
  Wrapped.displayName = Icon.displayName ?? "MaterialSymbolIcon";
  return Wrapped;
};

// Material Symbol icons (from @material-symbols/svg-300)
const rawMaterialIcons = {
  Sparkles: withCurrentColor("sparkles", SparklesSvg),
  TrendingUp: withCurrentColor("trending-up", TrendingUpSvg),
  DollarSign: withCurrentColor("dollar-sign", DollarSignSvg),
  ArrowLeftRight: withCurrentColor("arrow-left-right", ArrowLeftRightSvg),
  ArrowUp: withCurrentColor("arrow-up", ArrowUpSvg),
  Box: withCurrentColor("box", BoxSvg),
  Star: withCurrentColor("star", StarSvg),
  Lock: withCurrentColor("lock", LockSvg),
  Coins: withCurrentColor("coins", CoinsSvg),
  Building2: withCurrentColor("building2", Building2Svg),
  Users: withCurrentColor("users", UsersSvg),
  Handshake: withCurrentColor("handshake", HandshakeSvg),
  Menu: withCurrentColor("menu", MenuSvg),
  Search: withCurrentColor("search", SearchSvg),
  Person: withCurrentColor("person", PersonSvg),
  Account: withCurrentColor("account", AccountCircleSvg),
  Plus: withCurrentColor("plus", PlusSvg),
  Minus: withCurrentColor("minus", MinusSvg),
  ArrowUpRight: withCurrentColor("arrow-up-right", ArrowUpRightSvg),
  ChevronRight: withCurrentColor("chevron-right", ChevronRightSvg),
  ChevronDown: withCurrentColor("chevron-down", ChevronDownSvg),
  Volume2: withCurrentColor("volume2", Volume2Svg),
  X: withCurrentColor("close", CloseSvg),
  Globe: withCurrentColor("globe", GlobeSvg),
  ArrowForward: withCurrentColor("arrow-forward", ArrowForwardSvg),
  ArrowBack: withCurrentColor("arrow-back", ArrowBackSvg),
  KeyboardArrowRight: withCurrentColor("keyboard-arrow-right", KeyboardArrowRightSvg),
  KeyboardArrowDown: withCurrentColor("keyboard-arrow-down", KeyboardArrowDownSvg),
  Email: withCurrentColor("email", EmailSvg),
  Edit: withCurrentColor("edit", EditSvg),
  Location: withCurrentColor("location", LocationSvg),
  Phone: withCurrentColor("phone", PhoneSvg),
  Widgets: withCurrentColor("widgets", WidgetsSvg),
  Visibility: withCurrentColor("visibility", VisibilitySvg),
  Verified: withCurrentColor("verified", VerifiedSvg),
  AssuredWorkload: withCurrentColor("assured-workload", AssuredWorkloadSvg),
  CompareArrows: withCurrentColor("compare-arrows", CompareArrowsSvg),
  Token: withCurrentColor("token", TokenSvg),
  VerifiedUser: withCurrentColor("verified-user", VerifiedUserSvg),
  ShieldLock: withCurrentColor("shield-lock", ShieldLockSvg),
  RocketLaunch: withCurrentColor("rocket-launch", RocketLaunchSvg),
  Public: withCurrentColor("public", PublicSvg),
  PersonShield: withCurrentColor("person-shield", PersonShieldSvg),
  LocalLibrary: withCurrentColor("local-library", LocalLibrarySvg),
  Lightbulb: withCurrentColor("lightbulb", LightbulbSvg),
  Layers: withCurrentColor("layers", LayersSvg),
  VpnKey: withCurrentColor("vpn-key", VpnKeySvg),
  Group: withCurrentColor("group", GroupSvg),
  AdminPanelSettings: withCurrentColor("admin-panel-settings", AdminPanelSettingsSvg),
  Graph5: withCurrentColor("graph-5", Graph5Svg),
  Language: withCurrentColor("language", LanguageSvg),
  Gavel: withCurrentColor("gavel", GavelSvg),
  FastForward: withCurrentColor("fast-forward", FastForwardSvg),
  DonutSmall: withCurrentColor("donut-small", DonutSmallSvg),
  DonutLarge: withCurrentColor("donut-large", DonutLargeSvg),
  DeviceHub: withCurrentColor("device-hub", DeviceHubSvg),
  CandlestickChart: withCurrentColor("candlestick-chart", CandlestickChartSvg),
  Brick: withCurrentColor("brick", BrickSvg),
  Balance: withCurrentColor("balance", BalanceSvg),
  CurrencyExchange: withCurrentColor("currency-exchange", CurrencyExchangeSvg),
  Settings: withCurrentColor("settings", SettingsSvg),
  Api: withCurrentColor("api", ApiSvg),
  Acute: withCurrentColor("acute", AcuteSvg),
  History2: withCurrentColor("history-2", History2Svg),
  Whatshot: withCurrentColor("whatshot", WhatshotSvg),
} as const satisfies Record<string, IconComponent>;

// Custom SVG icons (from assets/svg)
const rawOtherIcons = {
  Instagram: withCurrentColor("instagram", InstagramSvg),
  Linkedin: withCurrentColor("linkedin", LinkedinSvg),
  Google: withCurrentColor("google", GoogleSvg),
  Facebook: withCurrentColor("facebook", FacebookSvg),
  Twitter: withCurrentColor("twitter", XSvg),
  BankShield: withCurrentColor("bank-shield", BankShield),
  Hexagon: withCurrentColor("hexagon", Hexagon),
  Stats: withCurrentColor("stats", Stats),
  Trading: withCurrentColor("trading", Trading),
  Documents: withCurrentColor("documents", Documents),
  Global: withCurrentColor("global", Global),
} as const satisfies Record<string, IconComponent>;

// Combined icons object for backward compatibility
const rawIcons = {
  ...rawMaterialIcons,
  ...rawOtherIcons,
} as const satisfies Record<string, IconComponent>;

const normalizedIcons = Object.entries(rawIcons).reduce<Record<string, IconComponent>>(
  (acc, [key, Icon]) => {
    acc[normalizeKey(key)] = Icon;
    return acc;
  },
  {},
);

export type IconName = keyof typeof rawIcons;
export type MaterialIconName = keyof typeof rawMaterialIcons;
export type OtherIconName = keyof typeof rawOtherIcons;

export const icons = rawIcons;
export const materialIcons = rawMaterialIcons;
export const otherIcons = rawOtherIcons;

export const tZeroLogo = tZeroLogoSvg;

export function icon(name: IconName | string): IconComponent {
  if (typeof name !== "string") {
    return rawIcons[name];
  }

  const cleanedName = stripStega(name) ?? name;
  const direct = rawIcons[cleanedName as IconName];
  if (direct) {
    return direct;
  }

  const normalized = normalizedIcons[normalizeKey(cleanedName)];
  if (!normalized) {
    throw new Error(`Unknown icon: ${name}`);
  }
  return normalized;
}

/**
 * Icon Component - Clean wrapper for rendering SVG icons
 *
 * Usage:
 * ```tsx
 * <Icon name="Phone" className="h-5 w-5 text-emerald-600" />
 * <Icon name="Phone" strokeWidth={2} className="text-emerald-600" /> // Bolder icon
 * ```
 */
export function Icon({
  name,
  size = 24,
  className,
  ...props
}: {
  name: IconName | string;
  size?: number;
  className?: string;
} & SVGProps<SVGSVGElement>) {
  const IconComponent = icon(name);
  return React.createElement(IconComponent, {
    className,
    width: size,
    height: size,
    ...props,
  });
}

export function iconOrNull(name: IconName | string | null | undefined): IconComponent | null {
  if (!name) return null;
  return icon(name as IconName) ?? null;
}

function normalizeKey(name: string) {
  const cleaned = stripStega(name) ?? name;
  return cleaned.toLowerCase().replace(/[\s_-]+/g, "");
}

// PNG Icon Image Functions
export type IconImageName = GeneratedIconImageName;

export const iconImages = rawIconImages;

const normalizedIconImages = Object.entries(rawIconImages).reduce<Record<string, StaticImageData>>(
  (acc, [key, image]) => {
    acc[normalizeKey(key)] = image as StaticImageData;
    return acc;
  },
  {},
);

export function iconImage(name: IconImageName | string): StaticImageData {
  if (typeof name !== "string") {
    return rawIconImages[name];
  }

  const cleanedName = stripStega(name) ?? name;
  const direct = rawIconImages[cleanedName as IconImageName];
  if (direct) {
    return direct;
  }

  const normalized = normalizedIconImages[normalizeKey(cleanedName)];
  if (!normalized) {
    throw new Error(`Unknown icon image: ${name}`);
  }
  return normalized;
}

export function iconImageComponent(
  name: IconImageName | string,
  size: number = 24,
): React.ReactNode {
  return <Image src={iconImage(name)} alt={name} width={size} height={size} />;
}

export function iconImageOrNull(
  name: IconImageName | string | null | undefined,
): StaticImageData | null {
  if (!name) return null;
  try {
    return iconImage(name as IconImageName);
  } catch {
    return null;
  }
}
